<p class="mb-0">
  <transloco
    id="23cbc4b5-035a-43ba-bd73-6dfcabf47d78"
    [key]="
      passwordUpdateMode === 'resetPassword'
        ? 'accountUi.updatePasswordDoneText.successfullySetNewPassword'
        : 'accountUi.updatePasswordDoneText.successfullySetPassword'
    "
    [params]="{ emailClass: 'text-p-40 email', email: this.email ?? '', id: '71a17d4d-0bda-414e-ac90-8e37fb36724e' }"></transloco>
</p>
